export const appStorage = localStorage;

export const clearOfflineStorage = () => null;
